import { Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useAlreadyDecidedMessage } from "../options/alreadyDecided";
import { requireDataFields } from "../typeguards";
import type { LeftFrom, SaveBeforeLeaving } from "./saveBeforeLeaving";
import { useContractState } from "./useContractState";

export const HeldBackNotice = ({ held, from }: { held: SaveBeforeLeaving; from: LeftFrom }) => {
  const { t } = useTranslation();
  const savedOptions = requireDataFields(useContractState().contract).options ?? [];
  const alreadyDecided = useAlreadyDecidedMessage(savedOptions);
  if (held.isSaving || held.heldFrom !== from) return null;
  const decidedElsewhere = held.optionsDecidedElsewhere.flatMap((id) =>
    savedOptions.filter((option) => option.id === id),
  );

  return (
    <>
      {held.saveFailed && (
        <Text role="alert" color="smError" fontSize="sm" textAlign="center" mt="2">
          {held.valueRefused
            ? t("Some fields were not saved. Correct the fields marked in red and try again.")
            : t("Some changes could not be saved. Try again.")}
        </Text>
      )}
      {decidedElsewhere.length > 0 && (
        <Stack role="status" spacing="1" mt="2" textAlign="center" data-testid="options-decided-elsewhere">
          {decidedElsewhere.map((option) => (
            <Text key={option.id} fontSize="sm">
              {alreadyDecided(option)}
            </Text>
          ))}
          <Text fontSize="sm">{t("Changes to a decided extension are not saved. Try again to continue.")}</Text>
        </Stack>
      )}
    </>
  );
};
